import numeral from "numeral";
import {provider} from "@/service/provider";
import axios from "axios";
import moment from 'moment';
import POSITION  from "../constants/position.js";

export default {
    data() {
        return {
            to_date                     : moment().format("YYYY-MM-DD"),
            from_date                   : moment().format("YYYY-MM-DD"),
            dialog                      : false,
            toggleAdd                   : false,
            valid                       : false,
            search                      : "",
            transaction_type            : "",
            product_type                : "",
            loading                     : false,
            pageCount                   : 0,
            pageList                    : [10, 20, 50, 100, 200],
            options                     : {},
            currentPage                 : 1,
            itemsPerPage                : 10,
            totalPage                   : 10,
            noLimit                     : 1000,
            dataList                    : [],
            dense                       : true,
            menuDate                    : false,
            menuDate1                   : false,
            menuDate2                   : false,
            menuDateFrom                : false,
            menuDateTo                  : false,
            overlay                     : false,
            paymentMethod               : ['wallet', 'cash'],
            paymentSettleFee            : [{value: '1', label: 'payNow'},{value: '0', label: 'payLater'}],
            provinceOptionList          : [],
            districtOptionList          : [],
            communeOptionList           : [],
            villageOptionList           : [],
            membershipRelationTypeList  : [
                'wife',
                'husband',
                "son",
                "daughter",
                "nephew",
                "niece",
                "cousin",
                "sibling",
                "aunt",
                "uncle",
                "mother",
                "father",
                "mother_in_law",
                "father_in_law",
                "grand_mother",
                "grand_father",
                "grand_son",
                "grand_daughter",
                "in_laws",
                "others",
            ],
            cardTypeOpt: ["id_card", "passport_number", "driver_license", "commune_certificate", "family_book", "residence_book", "birth_certificate"],
            genders: ['male', 'female'],
            disabilities: ['yes', 'no'],
            maritalStatuses: ['married', 'single', 'widow'],
            customerTypes: [
                'farmer',
                'beeShop',
                'crop_collector',
                'beeXPress',
                'beeDepo',
                'crop_trader',
                'miller',
                'supplier_agri-input',
                'supplier_rice',
                'buyer', 
                'consumer',
                'exporter',
                'truck_company',
                'quality_control'
            ]
        };
    },

    watch: {
        options: {
            handler() {
                this.sortBy = this.options.sortBy[0] || "";
                this.sortDesc = this.options.sortDesc[0] || "";
                this.fetchDataTable({
                    search: this.search,
                    offset: this.currentPage,
                    id: "",
                    limit: this.itemsPerPage,
                    sortBy: this.sortBy,
                    sortDesc: this.sortDesc
                });
            },
            deep: true
        }
    },
    computed: {
        language() {
            return this.$i18n.locale === 'km' ? 'kh':'en';
        },
        currentPageComputed: {
            get() {
                return this.currentPage;
            },
            set(value) {
                this.currentPage = numeral(value).value();
            }
        },
 
        isShop() {
            return this.$store.state.userDoc.type == POSITION.BEE_SHOP;
        },
         
        isAgent() {
            return this.$store.state.userDoc.type == POSITION.BEE_AGENT;
        },
         
        isExpress() {
            return this.$store.state.userDoc.type == POSITION.BEE_XPRESS;
        },
         
        isFarmer() {
            return this.$store.state.userDoc.type == POSITION.FARMER;
        },

        isDepo() {
            return this.$store.state.userDoc.type == POSITION.BEE_DEPO;
        },
         
        isOperator() {
            return this.$store.state.userDoc.type == POSITION.EMPLOYEE;
        },

        isSupplierAgriInput() {
            return this.$store.state.userDoc.type == POSITION.SUPPLIER_AGRI_INPUT;
        },

        isSupplierRice() {
            return this.$store.state.userDoc.type == POSITION.SUPPLIER_RICE;
        },

        isSupplierConsumption() {
            return this.$store.state.userDoc.type == POSITION.SUPPLIER_CONSUMPTION;
        },

        isCropTrader() {
            return this.$store.state.userDoc.type == POSITION.CROP_TRADER;
        },  

        isMiller() {
            return this.$store.state.userDoc.type == POSITION.MILLER;
        },
        isExporter() {
            return this.$store.state.userDoc.type == POSITION.EXPORTER;
        }
    },
    methods: {
        exportExcel(tableID, filename = ''){
            var table = document.getElementById(tableID);
            var cloneTable = table.cloneNode(true);
            if(cloneTable.querySelector('[aria-label="action"]')){
                cloneTable.querySelector('[aria-label="action"]').remove();
            }
            var downloadLink;
            var dataType = 'application/vnd.ms-excel';
            var tableSelect = cloneTable;
            var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

            filename = filename?filename+'.xls':'excel_data.xls';
            downloadLink = document.createElement("a");
            document.body.appendChild(downloadLink);
            downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
            downloadLink.download = filename;
            downloadLink.click();
        },

        getCurrencySymbol(currency_code) {
            return currency_code === "USD" ? "$" : currency_code === "KHR" ? "៛" : currency_code === "THB" ? "B" : "$";
        },
        ExcelDateToJSDate(date) {
            return new Date(Math.round((date - 25569) * 86400 * 1000));
        },
        reset() {
            if (this.$refs.formData) {
                this.$refs.formData.reset();
            }
        },
        parseFromDate(val) {
            if (val) {
                const [d, m, y] = val.split("-");
                return [y, m, d].join("-");
            }
            return ""
        },
        parseToDate(val) {
            if (val) {
                const [y, m, d] = val.split("-");
                return [d, m, y].join("-");
            }
            return "";
        },
        my_encrypt(value) {
            let result = "";
            for (let i = 0; i < value.length; i++) {
                if (i < value.length - 1) {
                    result += value.charCodeAt(i) + 7;
                    result += "eyJzdWIiOiIxMDAyNSIsImlzcyI6Imh0dHA6Ly9iZWVzaG9wLWRldi5iZWVhcHBzLnN5c3RlbXMvYXBpL2xvZ2";
                } else {
                    result += value.charCodeAt(i) + 7;
                }
            }
            return result;
        },

        my_decrypt(value) {
            let result = "";
            let array = value.split("eyJzdWIiOiIxMDAyNSIsImlzcyI6Imh0dHA6Ly9iZWVzaG9wLWRldi5iZWVhcHBzLnN5c3RlbXMvYXBpL2xvZ2");

            for (let i = 0; i < array.length; i++) {
                result += String.fromCharCode(array[i] - 7);
            }
            return result;
        },

        getColor(status) {
            let color = "";
            switch (status) {
                case "due":         color = 'error'; break;
                case "pending":     color = 'error'; break;
                case "order":       color = 'teal'; break;
                case "approved":    color = 'pink'; break;
                case "accepted":    color = 'blue'; break;
                case "declined":    color = "red"; break;
                case "rejected":    color = "red"; break;
                case "partial":     color = "warning"; break;
                case "completed":   color = "green"; break;
                case "finished":    color = "green"; break;
                case "paid":        color = 'green'; break;
                case "reviewed":    color = 'green'; break;
                case "authorized":  color = 'green'; break;
                default :           color = "teal"; break;
            }
            return color;
        },

        getProvince() {
            let vm = this;
            let url = provider.baseURL + provider.getProvince;
            let selector = {};
            selector.operator_id=localStorage.type==="employee" ? localStorage.id : "";
            return new Promise((resolve, reject) => {
                axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.provinceOptionList = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },
        getDistrict(province_code) {
            let vm = this;
            let url = provider.baseURL + provider.getDistrict;
            let selector = {};
            selector.province_code=province_code;
            selector.operator_id=localStorage.type==="employee" ? localStorage.id : "";

            return new Promise((resolve, reject) => {
                axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.districtOptionList = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },
        getCommune(district_code) {
            let vm = this;
            let url = provider.baseURL + provider.getCommune;
            let selector = {};
            selector.district_code=district_code;
            return new Promise((resolve, reject) => {
                axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.communeOptionList = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },
        getVillage(communce_code) {
            let vm = this;
            let url = provider.baseURL + provider.getVillage;
            let selector = {};
            selector.communce_code=communce_code;
            return new Promise((resolve, reject) => {
                axios.post(url, selector, {headers: {Authorization: localStorage.token}}).then(
                    res => {
                        if (res.data.response && res.data.response.code === 200) {
                            resolve(res.data.data);
                            vm.villageOptionList = res.data.data;
                        }
                    },
                    error => {
                        reject(error);
                    }
                );
            });
        },

        /** remove prefix code area ex: +855 */
        formatPhoneNumber(val){
            if(val){
                return val.replace(/^\+855/, '0')
            }
            return val;
        },
        formatNumber(x){
            if (x) {
                x = parseFloat(x);
                let parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            } else {
                return "0";
            }
        },
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        numberWithComma(value) {
            if (value) {
                value = parseInt(value).toFixed(2);
                value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            return value;
        },
        
        /** remove prefix code area ex: +855 */
        formatPhoneNumber(val){
            if(val){
                return val.replace(/^\+855/, '0')
            }
            return val;
        },

        formatNumber(x){
            if (x) {
                x = parseFloat(x);
                let parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            } else {
                return "0";
            }
        },

        dateFormat(val) {
            if (val) {
                return moment(val, 'DD-MM-YYYY').format('DD-MMM-YYYY');
            } else {
                return "";
            }
        },
    },

    created(){
        this.from_date = moment(this.to_date).subtract(90, 'days').endOf('day').format('YYYY-MM-DD');
    }

};

